import { QuestionTypeChip, QContentStatusTag } from '@exam-management/components';
import { type QuestionStatus } from '@exam-management/graphql';
import { type GridColDef, Text } from '@shared/components';

type QuestionType = 'single' | 'item-set';

export interface LOSQuestionRow {
  id: string;
  refCode: string;
  type: QuestionType;
  itemSetName?: string;
  status: QuestionStatus;
  questionGroupId?: string;
}

export const columns: GridColDef<LOSQuestionRow>[] = [
  {
    field: 'refCode',
    headerName: 'QID',
    width: 200,
    sortable: false,
    renderCell: ({ value }) => <Text variant='body2'>{value}</Text>,
  },
  {
    field: 'type',
    headerName: 'QType',
    width: 120,
    sortable: false,
    renderCell: ({ row }) => <QuestionTypeChip type={row.type} />,
  },
  {
    field: 'itemSetName',
    headerName: 'Item Set Name',
    flex: 1,
    sortable: false,
    renderCell: ({ value }) => <Text variant='body2'>{value ?? '—'}</Text>,
  },
  {
    field: 'status',
    headerName: 'สถานะ',
    width: 180,
    sortable: false,
    renderCell: ({ value }) => <QContentStatusTag status={value} />,
  },
];
